export default __webpack_public_path__ + "static/media/layamr-web2.8b842d4a.jpg";